import type { StyleElements } from "replo-runtime/shared/utils/styles";
import type { ComponentConfig } from "../../components";

export const customProperties = {
  width: "--rwi",
  height: "--rhe",
};

const styleElements = {
  root: {
    defaultStyles: {
      overflow: "hidden",
      width: `var(${customProperties.width}, auto)`,
      height: `var(${customProperties.height}, auto)`,
    },
  },
} satisfies StyleElements;

const config = {
  renderData: {
    customProps: [
      {
        id: "_embedHtml",
        type: "string",
        name: "Youtube Embed Code",
        defaultValue: null,
        description:
          "Embed code copied from Youtube. Find from the video's Share button, then copy the text under Embed.",
      },
      {
        id: "_hideControls",
        type: "boolean",
        name: "Hide Controls",
        defaultValue: false,
        description:
          "If enabled, no play/pause or fullscreen controls will be shown while the video is playing.",
      },
    ],
    newInstancesUseNumbering: true,
    acceptsArbitraryChildren: () => false,
    isAlwaysDynamic: false,
    canvasIndicatorDragDirections: [],
    allowsLayoutModification: false,
    canContainChildren: false,
    styleElements,
  },
} satisfies ComponentConfig;

export default config;
